/*
  One dropdown holding both the country and the language.

  Dawn's own localization element writes every choice into the first
  country_code or locale_code input it finds, which breaks the moment both
  live in one form. Here each option names its field, so the right hidden
  input gets the value before the form submits.
*/
if (!customElements.get('localization-picker')) {
  customElements.define(
    'localization-picker',
    class LocalizationPicker extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.trigger = this.querySelector('.localization-picker__trigger');
        this.panel = this.querySelector('.localization-picker__panel');

        this.trigger.addEventListener('click', this.toggle.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.addEventListener('keyup', (event) => {
          if (event.code === 'Escape') this.close(true);
        });

        this.querySelectorAll('.localization-picker__option').forEach((option) =>
          option.addEventListener('click', this.onSelect.bind(this))
        );
      }

      get isOpen() {
        return this.trigger.getAttribute('aria-expanded') === 'true';
      }

      toggle() {
        this.isOpen ? this.close() : this.open();
      }

      open() {
        this.trigger.setAttribute('aria-expanded', 'true');
        this.panel.removeAttribute('hidden');
      }

      close(refocus) {
        this.trigger.setAttribute('aria-expanded', 'false');
        this.panel.setAttribute('hidden', true);
        if (refocus) this.trigger.focus();
      }

      onFocusOut() {
        setTimeout(() => {
          if (!this.contains(document.activeElement)) this.close();
        });
      }

      onSelect(event) {
        event.preventDefault();
        const { field, value } = event.currentTarget.dataset;
        const input = this.form.querySelector(`input[name="${field}"]`);
        if (!input) return;
        input.value = value;
        this.form.submit();
      }
    }
  );
}
